module.exports = __webpack_public_path__ + "img/close-positions.6548bdc7.svg";